import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {useActionBlockPreviewProps} from "~/cabinet/vue/client/events/action/types/useActionBlockPreview";
import {
    OnlineChatShowAnimationActionDescription
} from "~/cabinet/ts/data/events/ActionDescription";
import {computed} from "vue";
import {AnimationConfigWithPath} from "lottie-web";
import LottiePlayer from "~/core-ui/vue/ui/LottiePlayer.vue";


const __default__ = {
    name: "OnlineChatShowAnimationBlockPreview"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
        ...useActionBlockPreviewProps<OnlineChatShowAnimationActionDescription>()
    },
  setup(__props) {

let props = __props;

let url = computed(() => {
    let id = props.params.animationId;
    if (id) {
        return props.actionDescription.frontendParams.animations.find(item => id == item.id)?.url;
    }
    return null;
});

return (_ctx: any,_cache: any) => {
  return (_unref(url))
    ? (_openBlock(), _createBlock(LottiePlayer, {
        key: _unref(url),
        height: 150,
        options: {
            path: _unref(url),
            loop: false
        } as AnimationConfigWithPath
      }, null, 8, ["options"]))
    : _createCommentVNode("", true)
}
}

})